import React from 'react';
import PropTypes from 'prop-types';
import './Loader.css';

const Loader = ({ size = 'medium', fullScreen = false, text = 'Chargement...' }) => {
    return (
        <div className={`loader-container ${fullScreen ? 'fullscreen' : ''}`}>
            <div className={`loader ${size}`} role="status" aria-label="Chargement en cours">
                <div className="spinner"></div>
            </div>
            {text && <p className="loader-text">{text}</p>}
        </div>
    );
};

Loader.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    fullScreen: PropTypes.bool,
    text: PropTypes.string
};

export default Loader; 